import { EBundlesViewModel } from '@appcharge/shared-ui';
import { TemplateStudioModel } from 'common/contracts';
import { BannerAspectRatio, DEFAULT_BODY_BLOCKS_ORDER } from 'constants/enums';

import { bannerDesigns } from 'components/TemplatesStudio/DesignsMetadata/banners.metadata';
import { bundleDesigns } from 'components/TemplatesStudio/DesignsMetadata/bundles.metadata';
import { promotionDesigns } from 'components/TemplatesStudio/DesignsMetadata/promotions.metadata';
import { rollingOffersDesigns } from 'components/TemplatesStudio/DesignsMetadata/rollingOffers.metadata';
import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';

export const defaultTemplateStudioFormValues: Partial<TemplateStudioModel> = {
  templateName: 'Template Name',
  description: '',
  tags: [],
  bodyBlocksOrder: DEFAULT_BODY_BLOCKS_ORDER,
  header: {
    showPlayerName: false,
    showPlayerId: false,
    isSticky: false,
    backgroundOpacity: 0,
    textColor: { colorOne: '#FFFFFF' }
  },
  banner: {
    selectedDesignId: bannerDesigns.fourOnOne.id
  },
  promotion: {
    themes: [],
    maxSupportedProducts: 1,
    selectedDesignId: promotionDesigns.dynamic.id
  },
  bundle: {
    offersPerRow: null,
    bundleViewModel: EBundlesViewModel.LINEAR,
    themes: [],
    maxSupportedProducts: 1,
    selectedDesignId: bundleDesigns.defaultLinear.id
  },
  popup: {
    popupRatio: BannerAspectRatio.SQUARE
  },
  rollingOffers: {
    desktopLayout: ETemplateStudioLayoutOptions.HORIZONTAL,
    themes: [],
    selectedDesignId: rollingOffersDesigns.duo.id
  },
  richText: {
    text: '',
    fontColor: 'rgb(0, 0, 0)'
  },
  dailyBonusBadge: {
    selectedDesignId: 'default-daily-bonus-design'
  },
  footer: {
    showAppchargeLogo: false,
    backgroundOpacity: 0,
    textColor: { colorOne: '#CB1010' }
  }
};
